import { jsxs as u, jsx as o, Fragment as C } from "react/jsx-runtime";
import { withManagedProps as k } from "@made-people/managed-props";
import { z as n } from "zod";
import { withZod as S } from "@made-people/react-prop-guard";
import p, { useContext as x, createElement as Je, useState as M, useRef as be, useEffect as F, createContext as W, useMemo as ne, Children as Xe, useCallback as ve, memo as P, useReducer as Ze, useId as en } from "react";
import { deckStyles as ue, sidebarStyles as me, foldout2Styling as J, deck2Blueprint as _, foldoutStyling as nn, featuredImageStyling as tn, featuredProductsStyling as ge, menuItemStyling as fe } from "./index-blueprint.es.js";
import { motion as v, AnimatePresence as w, cubicBezier as X } from "motion/react";
import ye from "react-use-measure";
import { useEscKey as ke } from "@made-people/blueprint-ui-hooks";
import A, { clsx as he } from "clsx";
import { overlayEventEmitter as E, useOverlayState as on, GLOBAL_OVERLAY_ID as B } from "@made-people/blueprint-overlay";
import { buttonAsLinkSchema as Se, ButtonAsLink as Ie } from "@made-people/blueprint-button";
import { badgeSchema as $, Badge as G } from "@made-people/blueprint-badge";
import { responsiveImageSchema as Ne, ResponsiveImage as te } from "@made-people/blueprint-responsive-image";
import { siteSettingsTriggerSchema as an, SiteSettingsTrigger as sn } from "@made-people/blueprint-site-settings";
import { linkAsLinkSchema as Me, LinkAsLink as we, LinkAsSpan as ln } from "@made-people/blueprint-link";
import { Drawer as T } from "@made-people/blueprint-drawer";
import { AngleLeftIcon as xe, AngleRightIcon as ie, CrossIcon as Ce } from "@made-people/blueprint-icons";
import { useLink as oe } from "@made-people/grease-link";
import { ProductProvider as rn, useProductBase as cn, useProductImages as dn } from "@made-people/grease-product";
import { useSearchResultItems as un } from "@made-people/grease-search";
import { componentWrapperSchema as mn, ComponentWrapper as hn } from "@made-people/blueprint-component-wrapper";
import { nanoid as pn } from "nanoid";
import "@made-people/blueprint";
const R = n.object({
  label: n.string(),
  id: n.string(),
  featured: n.boolean().optional(),
  link: n.string().optional(),
  image: n.string().optional()
}), bn = n.object({
  submenu: n.array(R).optional()
}).merge(R), vn = n.object({
  submenu: n.array(bn).optional()
}).merge(R), Z = n.object({
  submenu: n.array(vn).optional()
}).merge(R), gn = n.object({
  title: n.string().optional(),
  id: n.string(),
  items: n.object({
    id: n.string(),
    label: n.string().optional(),
    link: n.string().optional(),
    image: n.string().optional(),
    component: n.string().optional()
  }).array()
}), ae = n.object({
  navigation: Z.array(),
  content: gn.array().optional()
}), Ae = n.object({
  ...ae.shape,
  template: n.literal("hidden")
}), fn = k(
  "HiddenMenu",
  S(Ae, ({ navigation: e, content: t }) => /* @__PURE__ */ u("div", { className: "hidden", children: [
    e.map((i) => /* @__PURE__ */ o("a", { href: i.link, children: i.label })),
    /* @__PURE__ */ u("div", { children: [
      e.map((i) => {
        var a;
        return /* @__PURE__ */ o("div", { children: (a = i.submenu) == null ? void 0 : a.map(
          ({ label: s, submenu: l, link: r, id: c, image: d }) => /* @__PURE__ */ u("div", { children: [
            /* @__PURE__ */ o("a", { href: r, children: s }),
            l == null ? void 0 : l.map(({ label: m, link: g, featured: f }) => /* @__PURE__ */ o("a", { href: g, children: m }))
          ] })
        ) });
      }),
      /* @__PURE__ */ o("div", { children: t == null ? void 0 : t.map(({ items: i }) => /* @__PURE__ */ o("div", { children: i.map(({ label: a, link: s }) => /* @__PURE__ */ o("a", { href: s, children: a })) })) })
    ] })
  ] }))
), yn = ({
  content: e
}) => {
  const { slots: t } = x(D);
  return /* @__PURE__ */ o(v.div, { layout: !0, className: t == null ? void 0 : t.contentWrapper, children: e == null ? void 0 : e.map(({ items: i, id: a }, s) => /* @__PURE__ */ o("div", { className: t == null ? void 0 : t.contentSection, children: i.map(({ label: l, id: r, link: c }, d) => /* @__PURE__ */ o(
    v.a,
    {
      href: c,
      transition: {
        duration: 0.2,
        ease: "easeInOut",
        delay: 0.05 * d + s * 0.1
      },
      initial: { opacity: 0, y: -10 },
      animate: { opacity: 1, y: 0 },
      exit: {
        opacity: 0,
        y: 10
      },
      className: t == null ? void 0 : t.contentSectionItem,
      children: l
    },
    r
  )) }, a)) }, "content");
}, kn = ({
  image: e,
  label: t,
  link: i,
  columnIndex: a,
  id: s
}) => {
  const { slots: l } = x(D);
  return e ? /* @__PURE__ */ o(
    v.a,
    {
      layout: !0,
      href: i,
      className: l == null ? void 0 : l.imageItemLink,
      transition: {
        duration: 0.5,
        ease: "easeInOut",
        delay: 0.15 * a
      },
      initial: { opacity: 0, y: -10 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: 10 },
      children: /* @__PURE__ */ o("img", { src: e, alt: t, className: l == null ? void 0 : l.imageItem })
    },
    s
  ) : null;
}, Sn = (e) => {
  const { slots: t } = x(D), { label: i, submenu: a, id: s, image: l, link: r, index: c } = e;
  return /* @__PURE__ */ u(w, { mode: "wait", children: [
    /* @__PURE__ */ o(kn, { ...e, columnIndex: c }),
    !l && /* @__PURE__ */ u(v.div, { layoutId: s, className: t == null ? void 0 : t.menuSection, children: [
      /* @__PURE__ */ o(v.a, { href: r, className: t == null ? void 0 : t.menuSectionLabel, children: i }),
      /* @__PURE__ */ o(v.div, { className: t == null ? void 0 : t.menuSectionItems, children: a == null ? void 0 : a.map(({ label: d, link: m, featured: g, id: f }, N) => /* @__PURE__ */ o(
        v.a,
        {
          href: m,
          transition: {
            duration: 0.2,
            ease: "easeInOut",
            delay: 0.05 * N + c * 0.1
          },
          initial: { opacity: 0, y: -10 },
          animate: { opacity: 1, y: 0 },
          exit: {
            opacity: 0,
            y: 10
          },
          className: t == null ? void 0 : t.menuSectionItem,
          "data-featured": g ? "true" : "false",
          children: d
        },
        f
      )) })
    ] }, s)
  ] });
}, In = () => {
  var i;
  const { slots: e, activeMenu: t } = x(D);
  return /* @__PURE__ */ o(v.section, { layout: !0, className: e == null ? void 0 : e.activeMenuWrapper, children: (i = t == null ? void 0 : t.submenu) == null ? void 0 : i.map((a, s) => /* @__PURE__ */ Je(Sn, { ...a, key: a.id, index: s })) });
}, Nn = () => {
  let e = null;
  const { slots: t, setActiveMenu: i, activeMenu: a } = x(D);
  return !i || !a ? null : /* @__PURE__ */ o(w, { children: a !== null && /* @__PURE__ */ o(
    v.div,
    {
      onClick: () => i(null),
      onMouseEnter: () => {
        e = setTimeout(() => {
          i(null);
        }, 200);
      },
      onMouseLeave: () => e && clearTimeout(e),
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: [1, 1, 0], transition: { delay: 0.1 } },
      className: t == null ? void 0 : t.overlay
    }
  ) });
}, Q = n.literal("hamburger").or(n.literal("links")).optional(), Ee = Q.or(
  n.object({
    initial: Q,
    lg: Q
  })
), St = n.object({
  slots: n.object({
    triggers: n.string().optional(),
    trigger: n.string().optional()
  }),
  navigation: n.array(Z),
  activeMenu: Z.optional().nullable(),
  setActiveMenu: n.custom(),
  triggerSettings: Ee
}), se = p.forwardRef(
  ({ setActiveMenu: e, slots: t, navigation: i, activeMenu: a, triggerSettings: s }, l) => {
    const r = (m) => {
      if (typeof s == "string")
        return s === m ? "block" : "hidden";
      if (typeof s == "object") {
        const g = s.initial === m ? "block" : "hidden", f = s.lg === m ? "lg:block" : "lg:hidden";
        return `${g} ${f}`;
      }
      return m === "links" ? "block" : "hidden";
    }, c = r("hamburger"), d = r("links");
    return /* @__PURE__ */ u(C, { children: [
      /* @__PURE__ */ o(
        "div",
        {
          className: he(c, t.triggers),
          ref: l,
          children: /* @__PURE__ */ o(v.button, { className: t.trigger, children: "☰" })
        }
      ),
      /* @__PURE__ */ o("div", { className: he(t.triggers, d), ref: l, children: i.map((m) => /* @__PURE__ */ o(
        v.button,
        {
          onHoverStart: () => e(m),
          onClick: () => e(m),
          onFocus: () => e(m),
          "data-is-active": m.id === (a == null ? void 0 : a.id) ? "true" : "false",
          className: t.trigger,
          children: m.label
        },
        m.id
      )) })
    ] });
  }
);
se.displayName = "Triggers";
const Pe = n.object({
  ...ae.shape,
  styles: n.custom().optional(),
  template: n.literal("deck")
}), D = p.createContext({
  activeMenu: null
}), He = k(
  "DeckMenu",
  S(Pe, ({ styles: e, navigation: t, content: i }) => {
    const a = ue.styles(e), [s, l] = ye(), [r, c] = M(null);
    return ke(() => c(null)), /* @__PURE__ */ o(C, { children: /* @__PURE__ */ u(
      D.Provider,
      {
        value: {
          slots: ue.styles(e),
          activeMenu: r,
          setActiveMenu: c
        },
        children: [
          /* @__PURE__ */ o(
            se,
            {
              slots: {
                triggers: a.triggers,
                trigger: a.trigger
              },
              navigation: t,
              setActiveMenu: c,
              activeMenu: r,
              ref: s
            }
          ),
          /* @__PURE__ */ o(Nn, {}),
          /* @__PURE__ */ o(w, { children: r && /* @__PURE__ */ u(
            v.div,
            {
              animate: { y: l.y + l.height + 24, scaleY: 1 },
              initial: { y: 0, scaleY: 0.9 },
              exit: {
                y: l.y,
                height: l.height,
                scaleY: 0.9,
                overflow: "hidden"
              },
              transition: {
                type: "spring",
                damping: 17,
                stiffness: 170
              },
              className: a.mainNavigationWrapper,
              children: [
                r && /* @__PURE__ */ o(In, {}),
                i && /* @__PURE__ */ o(yn, { content: i })
              ]
            }
          ) })
        ]
      }
    ) });
  })
);
He.displayName = "DeckMenu";
const Le = n.object({
  ...ae.shape,
  styles: n.custom().optional(),
  template: n.literal("sidebar"),
  triggerSettings: Ee
}), Mn = p.createContext({
  activeMenu: null
}), De = k(
  "SidebarMenu",
  S(
    Le,
    ({ styles: e, navigation: t, content: i, triggerSettings: a }) => {
      const s = me.styles(e), [l, r] = ye(), [c, d] = M(null);
      return ke(() => d(null)), /* @__PURE__ */ o(C, { children: /* @__PURE__ */ u(
        Mn.Provider,
        {
          value: {
            slots: me.styles(e),
            activeMenu: c,
            setActiveMenu: d
          },
          children: [
            /* @__PURE__ */ o(
              se,
              {
                slots: s,
                navigation: t,
                setActiveMenu: d,
                activeMenu: c,
                triggerSettings: a
              }
            ),
            /* @__PURE__ */ o(w, { children: c && /* @__PURE__ */ o(
              v.div,
              {
                animate: { y: r.y + r.height + 24, scaleY: 1 },
                initial: { y: 0, scaleY: 0.9 },
                exit: {
                  y: r.y,
                  height: r.height,
                  scaleY: 0.9,
                  overflow: "hidden"
                },
                transition: {
                  type: "spring",
                  damping: 17,
                  stiffness: 170
                },
                className: s.mainNavigationWrapper,
                children: c && /* @__PURE__ */ u("span", { children: [
                  "ACTIVE MENU ",
                  c.label
                ] })
              }
            ) })
          ]
        }
      ) });
    }
  )
);
De.displayName = "SidebarMenu";
const ee = n.object({
  level: n.number(),
  // The current level of the active menu item
  label: n.string(),
  // The label of the active menu item
  id: n.string()
  // The unique ID of the active menu item
}).nullable(), pe = n.array(ee), wn = n.object({
  children: n.any().optional(),
  active: ee,
  // Now active can be null.
  setActive: n.function().args(ee).returns(n.void()),
  history: pe,
  // Stack of previous active states
  setHistory: n.function().args(pe).returns(n.void()),
  nextLevel: n.function().args(n.number(), n.string(), n.string()).returns(n.void()),
  prevLevel: n.function().returns(n.void()),
  prevActiveId: n.string().nullable(),
  setPrevActiveId: n.function().args(n.string().nullable()).returns(n.void()),
  closeMenu: n.function().returns(n.void()),
  // Close the menu
  headerHeight: n.number().nullable().optional(),
  setHeaderHeight: n.function().args(n.number().nullable()).returns(n.void()),
  footerHeight: n.number().nullable().optional(),
  setFooterHeight: n.function().args(n.number().nullable()).returns(n.void())
}), Te = p.createContext(void 0), xn = k(
  "MenuProvider",
  S(
    wn.omit({
      active: !0,
      setActive: !0,
      history: !0,
      setHistory: !0,
      nextLevel: !0,
      prevLevel: !0,
      prevActiveId: !0,
      setPrevActiveId: !0,
      closeMenu: !0,
      headerHeight: !0,
      setHeaderHeight: !0,
      footerHeight: !0,
      setFooterHeight: !0
    }),
    ({ children: e }) => {
      const [t, i] = M({
        level: 1,
        label: "Menu",
        id: "0"
      }), [a, s] = M([]), [l, r] = M(null), [c, d] = M(null), [m, g] = M(null);
      M(), p.useEffect(() => {
        if (t && t.id !== l) {
          const h = setTimeout(() => r(t.id), 500);
          return () => clearTimeout(h);
        }
      }, [t, l]);
      const f = (h, b) => {
        h === "next" && b ? (s((y) => [...y, t]), i(b)) : h === "prev" && s((y) => {
          if (y.length === 0)
            return y;
          const I = y.pop();
          return I && i(I), [...y];
        });
      }, N = () => {
        E.emit("close", {});
      };
      return /* @__PURE__ */ o(
        Te.Provider,
        {
          value: {
            active: t,
            setActive: i,
            history: a,
            setHistory: s,
            prevActiveId: l,
            setPrevActiveId: r,
            nextLevel: (h, b, y) => f("next", { level: h, label: b, id: y }),
            prevLevel: () => f("prev"),
            closeMenu: N,
            headerHeight: c,
            setHeaderHeight: d,
            footerHeight: m,
            setFooterHeight: g
          },
          children: e
        }
      );
    }
  )
), j = () => {
  const e = p.useContext(Te);
  if (!e)
    throw new Error("useMenu must be used within a MenuProvider");
  return e;
}, Be = n.object({
  variants: n.custom().optional(),
  text: n.string().optional(),
  as: n.enum(["button", "text"]).optional(),
  buttons: Se.array().optional(),
  closeIcon: n.custom().optional(),
  prevIcon: n.custom().optional(),
  onHeightChange: n.function(n.tuple([n.number()]), n.void()).optional()
}), Cn = k(
  "Foldout2MenuHeader",
  S(
    Be,
    ({ ...e }) => {
      var c;
      const { active: t, history: i, prevLevel: a, closeMenu: s } = j(), l = J.main.styles(e.variants), r = be(null);
      return F(() => {
        r.current && e.onHeightChange && e.onHeightChange(r.current.offsetHeight);
      }, [e.onHeightChange]), /* @__PURE__ */ u("div", { className: l.header, ref: r, children: [
        /* @__PURE__ */ o(w, { mode: "wait", children: ((e == null ? void 0 : e.as) !== "button" || i.length > 0) && /* @__PURE__ */ u(C, { children: [
          i.length > 0 && /* @__PURE__ */ u(C, { children: [
            /* @__PURE__ */ o(
              v.button,
              {
                className: l.backButton,
                onClick: a,
                animate: {
                  y: "0",
                  transition: {
                    type: "spring",
                    delay: 0.1,
                    duration: 0.5,
                    damping: 22,
                    stiffness: 170
                  }
                },
                initial: { y: "-100px" },
                exit: {
                  opacity: 0,
                  y: "-100px",
                  transition: {
                    delay: 0.2,
                    duration: 0.2
                  }
                },
                children: e.prevIcon
              }
            ),
            /* @__PURE__ */ o(
              v.span,
              {
                className: l.title,
                onClick: a,
                animate: {
                  y: "0",
                  opacity: 1,
                  transition: {
                    type: "spring",
                    delay: 0.15,
                    duration: 0.5,
                    damping: 22,
                    stiffness: 170
                  }
                },
                initial: { opacity: "0", y: "-100px" },
                exit: {
                  opacity: 0,
                  y: "-100px",
                  transition: {
                    delay: 0.15,
                    duration: 0.2
                  }
                },
                children: t.label
              }
            )
          ] }),
          e.closeIcon && /* @__PURE__ */ o(
            v.button,
            {
              onClick: s,
              className: l.closeButtonInside,
              animate: {
                y: "0",
                transition: {
                  type: "spring",
                  delay: 0.2,
                  duration: 0.5,
                  damping: 22,
                  stiffness: 170
                }
              },
              initial: { y: "-100px" },
              exit: {
                opacity: 0,
                y: "-100px",
                transition: {
                  delay: 0.1,
                  duration: 0.2
                }
              },
              children: e.closeIcon
            }
          )
        ] }) }),
        e.as === "button" && ((c = e.buttons) == null ? void 0 : c.length) && i.length === 0 && e.buttons.map((d, m) => /* @__PURE__ */ o(w, { mode: "wait", children: /* @__PURE__ */ o(
          v.div,
          {
            className: A(
              l.buttonWrapper,
              "absolute top-0 left-0 w-full h-full"
            ),
            animate: {
              y: "0",
              transition: {
                type: "spring",
                delay: 0.2,
                duration: 0.5,
                damping: 22,
                stiffness: 170
              }
            },
            initial: { y: "-100px" },
            exit: {
              opacity: "0",
              y: "-100px",
              transition: {
                delay: 0.1,
                duration: 0.2
              }
            },
            children: /* @__PURE__ */ o(
              Ie,
              {
                ...d,
                context: "menu",
                variants: {
                  ...d.variants,
                  size: "md"
                }
              }
            )
          }
        ) }, "button-index-" + m))
      ] });
    }
  )
), je = n.object({
  variants: n.custom().optional(),
  // Styling variants for the menu item
  children: n.custom().optional(),
  parentId: n.string().optional(),
  heading: n.object({
    heading: n.string().optional(),
    badge: $.extend({
      enabled: n.boolean().optional()
    }).optional()
  }).optional(),
  level: n.number().optional(),
  slideOpen: n.boolean().optional()
}), An = n.object({
  href: n.string().optional()
}), Y = n.object({
  variants: n.custom().optional(),
  // Styling variants for the menu item
  blueprint: n.custom().optional(),
  // So that a blueprint file can be passed down from the provider
  label: n.string().optional(),
  // Display label for the menu item
  badge: $.optional(),
  submenu: je.optional(),
  id: n.string().optional(),
  // Unique ID for the menu item
  style: n.any().optional(),
  // Custom inline styles for the menu item
  parentLabel: n.string().optional(),
  // Label of the parent menu item
  parentId: n.string().optional(),
  // ID of the parent menu item
  link: An.optional(),
  children: n.custom().optional(),
  nextIcon: n.custom().optional(),
  level: n.number().optional(),
  onMouseEnter: n.function().args(n.any()).returns(n.void()).optional(),
  // Optional onMouseEnter handler
  onMouseLeave: n.function().args(n.any()).returns(n.void()).optional(),
  // Optional onMouseLeave handler
  image: Ne.optional()
}), Oe = n.object({
  variants: n.custom().optional(),
  template: n.literal("foldout2"),
  closeBtn: n.object({
    placement: n.enum(["outside", "inside"]).optional()
  }).optional(),
  header: Be.optional(),
  open: n.boolean().optional(),
  nextIcon: n.custom().optional(),
  prevIcon: n.custom().optional(),
  closeIcon: n.custom().optional(),
  children: n.custom().optional(),
  customOverlayId: n.string().optional(),
  direction: n.enum(["bottom", "top", "left", "right"]).optional(),
  menuItem: Y.optional(),
  siteSettingsTrigger: an.optional()
}), Ve = n.object({
  template: n.literal("deck2"),
  closeBtn: n.object({
    placement: n.enum(["outside", "inside"]).optional()
  }).optional(),
  open: n.boolean().optional(),
  children: n.custom().optional(),
  customOverlayId: n.string().optional(),
  closeSubmenu: n.boolean().optional(),
  menuItem: Y.optional(),
  links: Me.optional()
  // Used for setting default-props on the <Link /> component
}), le = (e) => {
  var t, i;
  return p.isValidElement(e) ? ((t = e.props) == null ? void 0 : t.component) === "MenuItem" ? !0 : p.Children.toArray((i = e.props) == null ? void 0 : i.children).some(le) : !1;
}, It = (e) => {
  var t;
  return p.isValidElement(e) ? ((t = e.props) == null ? void 0 : t.component) === "ButtonAsLink" : !1;
}, Re = W(void 0);
function Fe() {
  return x(Re);
}
const En = k(
  "Foldout2Menu",
  S(
    {
      schema: Oe,
      defaultProps: {
        template: "foldout2",
        closeBtn: { placement: "outside" },
        prevIcon: /* @__PURE__ */ o(xe, {}),
        nextIcon: /* @__PURE__ */ o(ie, {}),
        closeIcon: /* @__PURE__ */ o(Ce, {}),
        direction: "left",
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({ ...e }) => {
      var N, h;
      const {
        active: t,
        closeMenu: i,
        setActive: a,
        setHistory: s,
        setPrevActiveId: l,
        setHeaderHeight: r,
        headerHeight: c
      } = j(), d = J.main.styles(e.variants), m = on(e.customOverlayId);
      F(() => {
        function b({ overlayId: y }) {
          var I;
          y === m.overlayId && (a({
            level: 1,
            label: ((I = e.header) == null ? void 0 : I.text) || "",
            id: "0"
          }), s([]), l(null));
        }
        return E.on("open", b), () => E.off("open", b);
      }, []);
      const g = ne(
        () => Xe.map(e.children, (b) => !p.isValidElement(b) || le(b) ? b : /* @__PURE__ */ o("div", { className: d.component, children: p.cloneElement(
          b,
          b.props,
          p.Children.map(
            b.props.children,
            (y) => p.isValidElement(y) ? p.cloneElement(
              y,
              {
                layout: {
                  spacing: { applySpacing: "false" },
                  position: { applyPosition: "false" }
                },
                context: "menu"
              }
            ) : y
          )
        ) })),
        [e.children]
      ), f = (b) => {
        r(b);
      };
      return /* @__PURE__ */ o(Re.Provider, { value: J.menuItem, children: /* @__PURE__ */ o(
        T,
        {
          hasHandle: !1,
          direction: e.direction,
          variants: { direction: e.direction, background: "none" },
          customOverlayId: m.overlayId,
          handleOnly: !0,
          children: /* @__PURE__ */ u(T.Content, { children: [
            /* @__PURE__ */ o(w, { children: ((N = e.closeBtn) == null ? void 0 : N.placement) === "outside" && m.isOpen && /* @__PURE__ */ o(
              v.button,
              {
                onClick: i,
                className: d.closeButtonOutside,
                animate: {
                  x: "0",
                  transition: {
                    type: "spring",
                    delay: 0.1,
                    duration: 0.5,
                    damping: 17,
                    stiffness: 170
                  }
                },
                initial: { x: "-200%" },
                exit: {
                  opacity: "0",
                  x: "-200%",
                  transition: {
                    delay: 0.1,
                    duration: 0.2
                  }
                },
                children: e.closeIcon
              }
            ) }),
            /* @__PURE__ */ u("div", { className: A(d.wrapper, "relative"), children: [
              /* @__PURE__ */ o(T.Title, { children: /* @__PURE__ */ o(
                Cn,
                {
                  onHeightChange: f,
                  ...e.header,
                  prevIcon: e.prevIcon,
                  closeIcon: ((h = e.closeBtn) == null ? void 0 : h.placement) === "inside" ? e.closeIcon : null
                }
              ) }),
              /* @__PURE__ */ o("div", { className: "overflow-hidden", children: /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    transform: `translateX(-${100 * (t.level - 1)}%)`
                  },
                  className: "transition-transform ease-[cubic-bezier(0.77,0,0.18,1)] duration-[500ms]",
                  children: /* @__PURE__ */ u(
                    "div",
                    {
                      className: A(
                        d.content,
                        "overflow-y-scroll scroll-smooth scrolling-touch"
                      ),
                      style: {
                        height: `calc(100dvh - ${c || 0}px)`
                      },
                      children: [
                        g,
                        /* @__PURE__ */ o(
                          sn,
                          {
                            ...e.siteSettingsTrigger,
                            className: d.siteSettingsTrigger
                          }
                        )
                      ]
                    }
                  )
                }
              ) })
            ] })
          ] })
        }
      ) });
    }
  )
);
function U(e) {
  if (p.isValidElement(e)) {
    if (e.type === p.Fragment)
      return p.Children.toArray(e.props.children).map(U);
    const t = p.Children.map(
      e.props.children,
      U
    );
    return p.cloneElement(e, {
      ...e.props,
      children: t
    });
  }
  return Array.isArray(e) ? e.map(U) : e;
}
function V(e) {
  if (Array.isArray(e))
    return e.length === 1 ? V(e[0]) : e.map(V);
  if (p.isValidElement(e)) {
    const t = V(e.props.children);
    return p.cloneElement(e, {
      ...e.props,
      children: t
    });
  }
  return e;
}
function Pn(e) {
  const t = [], i = {};
  return (Array.isArray(e) ? e : [e]).forEach((s, l) => {
    if (p.isValidElement(s)) {
      const r = s.props, c = r.id || `top-${l}`, d = { ...r, id: c };
      t.push(d);
      let m = [];
      r.children && (m = (Array.isArray(r.children) ? r.children : [r.children]).filter((f) => p.isValidElement(f)).map((f, N) => {
        const h = f.props, b = h.id || `${c}-child-${N}`;
        return { ...h, id: b, parentId: c };
      })), i[c] = m;
    }
  }), { topLevels: t, subMenus: i };
}
const We = Y.extend({
  linkSettings: Me.optional(),
  setActiveImage: n.function().args(n.custom()).returns(n.void()).optional()
});
function Hn(e, t, i) {
  var a;
  switch (t.type) {
    case "SET_ACTIVE":
      const s = (a = t.payload) != null && a.id ? i[t.payload.id] : [];
      return {
        ...e,
        active: t.payload,
        activeSubMenus: s,
        submenusActive: !!(s && s.length > 0)
      };
    case "SET_IGNORE_HOVER":
      return { ...e, ignoreHover: t.payload };
    default:
      return e;
  }
}
const _e = W(
  void 0
), $e = W(void 0);
function z() {
  const e = x(_e);
  if (!e)
    throw new Error(
      "useDeck2MenuState must be used within a Deck2MenuProvider"
    );
  return e;
}
function q() {
  const e = x($e);
  if (!e)
    throw new Error(
      "useDeck2MenuDispatch must be used within a Deck2MenuProvider"
    );
  return e;
}
function Ge() {
  const e = q(), t = be(null);
  return F(() => () => {
    t.current && (clearTimeout(t.current), e({ type: "SET_IGNORE_HOVER", payload: !1 }));
  }, [e]), ve(() => {
    e({ type: "SET_ACTIVE", payload: null }), e({ type: "SET_IGNORE_HOVER", payload: !0 }), t.current && clearTimeout(t.current), t.current = setTimeout(() => {
      e({ type: "SET_IGNORE_HOVER", payload: !1 }), t.current = null;
    }, 1e3), E.emit("close", { overlayId: B });
  }, [e]);
}
const Ye = P((e) => {
  var s;
  const t = Ge(), i = _.menuItem.styles(e.variants), a = {
    ...e.link,
    onClick: t
  };
  return (s = e.link) != null && s.href ? /* @__PURE__ */ o(
    we,
    {
      "data-testid": "deck2-menu-item",
      className: i.item,
      link: a,
      label: e.label,
      ...e.linkSettings
    }
  ) : /* @__PURE__ */ o(
    ln,
    {
      ...e.linkSettings,
      className: i.item,
      label: e.label
    }
  );
});
Ye.displayName = "Deck2MenuItem";
const Ln = k(
  "Deck2MenuItem",
  S(We, Ye)
), ze = W(void 0);
function re() {
  const e = x(ze);
  if (!e)
    throw new Error(
      "useDeck2MenuData must be used within a Deck2MenuDataProvider"
    );
  return e;
}
function Dn() {
  const { subMenus: e } = re(), t = q(), { active: i, ignoreHover: a } = z();
  return (s) => {
    const l = (e[s.id] ?? []).length > 0;
    if (!a && (i == null ? void 0 : i.id) !== s.id)
      if (t({ type: "SET_ACTIVE", payload: s }), l) {
        if (a)
          return;
        E.emit("open", { overlayId: B });
      } else
        E.emit("close", { overlayId: B });
  };
}
const Tn = P(({ links: e }) => {
  const t = Dn(), { topLevels: i } = re(), { submenusActive: a } = z(), s = _.main.styles();
  return /* @__PURE__ */ o(
    "div",
    {
      "data-testid": "deck2-topWrapper",
      className: A(s.wrapper, "relative"),
      children: /* @__PURE__ */ o("div", { className: s.topLevel, children: i.map((l) => l ? /* @__PURE__ */ o(
        "div",
        {
          "data-testid": "deck2-menuItem-" + l.id,
          onPointerEnter: () => t(l),
          className: A("cursor-pointer", {
            "active-submenu": a
          }),
          children: /* @__PURE__ */ o(Ln, { linkSettings: e, ...l })
        },
        l.id
      ) : null) })
    }
  );
}), Bn = {
  hidden: { opacity: 0, height: 0 },
  visible: {
    opacity: 1,
    height: "auto",
    transition: {
      staggerChildren: 0.05,
      duration: 0.3,
      ease: X(0.32, 0.72, 0, 1)
    }
  },
  exit: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.3,
      ease: X(0.32, 0.72, 0, 1)
    }
  }
}, jn = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: X(0.32, 0.72, 0, 1) }
  }
}, On = (e) => {
  var a, s;
  const t = Ge(), i = _.submenu.styles(e.variants);
  return /* @__PURE__ */ u(C, { children: [
    e.label && /* @__PURE__ */ o("div", { className: i.item, children: e.label }),
    /* @__PURE__ */ u("div", { "data-testid": `submenu-column-${e.id}`, className: i.submenu, children: [
      ((s = (a = e.submenu) == null ? void 0 : a.heading) == null ? void 0 : s.heading) && /* @__PURE__ */ o("div", { className: i.submenuHeading, children: e.submenu.heading.heading }),
      p.Children.map(e.children, (l, r) => {
        if (p.isValidElement(l)) {
          const c = {
            ...l.props.link,
            onClick: t
          };
          return /* @__PURE__ */ o(
            we,
            {
              className: i.item,
              link: c,
              label: l.props.label,
              onMouseEnter: () => {
                var d;
                e.setActiveImage && ((d = l.props) != null && d.image) && e.setActiveImage(l.props.image ?? null);
              },
              onMouseLeave: () => {
                e.setActiveImage && e.setActiveImage(null);
              },
              ...e.linkSettings
            },
            r
          );
        }
        return null;
      })
    ] })
  ] });
}, Vn = P(
  k(
    "Deck2Submenu",
    S(We, On)
  )
);
function Rn() {
  const { active: e } = z(), t = q();
  return (i) => {
    (e == null ? void 0 : e.id) === i.id && (t({ type: "SET_ACTIVE", payload: null }), E.emit("close", { overlayId: B }));
  };
}
const Fn = P(({ links: e }) => {
  var d, m, g;
  const { activeSubMenus: t, active: i } = z(), [a, s] = M(null), l = Rn(), r = _.main.styles();
  if (!(i != null && i.id))
    return null;
  const c = i.id;
  return /* @__PURE__ */ o("div", { "data-testid": "deck2-subWrapper", className: r.deckWrapper, children: /* @__PURE__ */ o(w, { children: t && t.length > 0 && /* @__PURE__ */ u(
    v.div,
    {
      onPointerLeave: () => {
        c && l({ id: c, label: "", level: 0 });
      },
      className: r.deckContent,
      variants: Bn,
      initial: "hidden",
      animate: "visible",
      exit: "exit",
      children: [
        /* @__PURE__ */ o(
          "div",
          {
            "data-testid": `submenu-${c}`,
            className: r.deckColumns,
            children: t.map((f) => /* @__PURE__ */ o(v.div, { variants: jn, children: /* @__PURE__ */ o(
              Vn,
              {
                ...f,
                linkSettings: e,
                setActiveImage: s
              }
            ) }, f.id))
          }
        ),
        (i == null ? void 0 : i.image) && /* @__PURE__ */ o(
          v.div,
          {
            initial: {
              opacity: 0
            },
            animate: {
              opacity: 1
            },
            exit: {
              opacity: 0
            },
            transition: {
              duration: 0.3
            },
            className: r.deckImageWrapper,
            children: /* @__PURE__ */ o(
              te,
              {
                className: r.deckImage,
                displaySize: {
                  mobile: "50vw",
                  tablet: "40vw",
                  desktop: "40vw"
                },
                initial: (d = a == null ? void 0 : a.initial) != null && d.src ? a == null ? void 0 : a.initial : i.image.initial
              }
            )
          },
          `deck-image-${(m = a == null ? void 0 : a.initial) != null && m.src ? a == null ? void 0 : a.initial.src : (g = i.image.initial) == null ? void 0 : g.src}`
        )
      ]
    },
    `submenu-${c}`
  ) }) });
}), Wn = P(
  (e) => /* @__PURE__ */ u(C, { children: [
    /* @__PURE__ */ o(Tn, { ...e }),
    /* @__PURE__ */ o(Fn, { ...e })
  ] })
), _n = P(() => {
  const e = q(), t = ve(
    (i) => {
      i.relatedTarget || (e({ type: "SET_ACTIVE", payload: null }), E.emit("close", { overlayId: B }));
    },
    [e]
  );
  return F(() => (window.addEventListener("pointerout", t), () => window.removeEventListener("pointerout", t)), [t]), null;
}), $n = {
  activeSubMenus: [],
  submenusActive: !1,
  active: null,
  ignoreHover: !1
}, qe = P((e) => {
  const { subMenus: t } = re(), [i, a] = Ze(
    (s, l) => Hn(s, l, t),
    $n
  );
  return /* @__PURE__ */ o(_e.Provider, { value: i, children: /* @__PURE__ */ u($e.Provider, { value: a, children: [
    /* @__PURE__ */ o(_n, {}),
    /* @__PURE__ */ o(Wn, { links: e.links })
  ] }) });
});
qe.displayName = "Deck2MenuStateProvider";
const Ke = P((e) => {
  const t = ne(() => {
    const a = V(e.children);
    return Pn(a);
  }, []), i = { ...e, children: void 0 };
  return /* @__PURE__ */ o(ze.Provider, { value: t, children: /* @__PURE__ */ o(qe, { ...i }) });
});
Ke.displayName = "Deck2MenuDataProvider";
const Gn = k(
  "Deck2Menu",
  S(
    {
      schema: Ve,
      defaultProps: { template: "deck2" }
    },
    Ke
  )
), Qe = n.object({
  variants: n.custom().optional(),
  template: n.literal("foldout"),
  closeBtn: n.object({
    placement: n.union([n.literal("outside"), n.literal("inside")]).optional()
  }).optional(),
  buttonAsMenuHeading: n.object({
    enabled: n.boolean().optional(),
    button: Se.optional()
  }).optional(),
  open: n.boolean().optional(),
  nextIcon: n.custom().optional(),
  prevIcon: n.custom().optional(),
  closeIcon: n.custom().optional(),
  children: n.custom().optional()
}), Yn = k(
  "FoldoutMenu",
  S(
    {
      schema: Qe,
      defaultProps: {
        template: "foldout",
        closeBtn: { placement: "outside" },
        open: !1,
        prevIcon: /* @__PURE__ */ o(xe, {}),
        nextIcon: /* @__PURE__ */ o(ie, {}),
        closeIcon: /* @__PURE__ */ o(Ce, {})
      }
    },
    ({ ...e }) => {
      var l, r, c, d;
      const { active: t, history: i, prevLevel: a } = j(), s = nn.main.styles(e.variants);
      return /* @__PURE__ */ o(
        T,
        {
          hasHandle: !1,
          direction: "left",
          variants: { direction: "left", background: "none" },
          children: /* @__PURE__ */ u(T.Content, { children: [
            /* @__PURE__ */ o(w, { children: ((l = e.closeBtn) == null ? void 0 : l.placement) === "outside" && /* @__PURE__ */ o(
              v.button,
              {
                className: s.closeButtonOutside,
                animate: {
                  x: "0",
                  transition: {
                    type: "spring",
                    delay: 0.1,
                    duration: 0.5,
                    damping: 17,
                    stiffness: 170
                  }
                },
                initial: { x: "-200%" },
                exit: {
                  opacity: "0",
                  transition: {
                    delay: 0,
                    duration: 0.2
                  }
                },
                children: e.closeIcon
              }
            ) }),
            /* @__PURE__ */ u("div", { className: A(s.wrapper, "relative"), children: [
              /* @__PURE__ */ u("div", { className: s.header, children: [
                !((r = e.buttonAsMenuHeading) != null && r.enabled) || i.length > 0 && /* @__PURE__ */ u(C, { children: [
                  i.length > 0 && /* @__PURE__ */ o(
                    "button",
                    {
                      className: s.backButton,
                      onClick: a,
                      children: e.prevIcon
                    }
                  ),
                  /* @__PURE__ */ o("span", { className: s.title, children: t.label }),
                  ((c = e.closeBtn) == null ? void 0 : c.placement) === "inside" && /* @__PURE__ */ o(
                    "button",
                    {
                      className: s.closeButtonInside,
                      children: e.closeIcon
                    }
                  )
                ] }),
                ((d = e.buttonAsMenuHeading) == null ? void 0 : d.enabled) && i.length === 0 && /* @__PURE__ */ o("div", { className: s.buttonWrapper, children: /* @__PURE__ */ o(
                  Ie,
                  {
                    link: { href: "http://www.google.com" },
                    context: "menu",
                    label: "All Products",
                    ...e.buttonAsMenuHeading.button
                  }
                ) })
              ] }),
              /* @__PURE__ */ o("div", { className: s.content, children: /* @__PURE__ */ o(
                "div",
                {
                  children: e.children
                }
              ) })
            ] })
          ] })
        }
      );
    }
  )
), zn = n.discriminatedUnion("template", [
  Pe,
  Ae,
  Le,
  Oe,
  Ve,
  Qe
]), Nt = k(
  "Menu",
  S(zn, (e) => {
    switch (e.template) {
      case "deck2":
        return /* @__PURE__ */ o(Gn, { ...e });
      default:
        return /* @__PURE__ */ o(xn, { ...e, children: e.template === "deck" ? /* @__PURE__ */ o(He, { ...e }) : e.template === "sidebar" ? /* @__PURE__ */ o(De, { ...e }) : e.template === "hidden" ? /* @__PURE__ */ o(fn, { ...e }) : e.template === "foldout" ? /* @__PURE__ */ o(Yn, { ...e }) : e.template === "foldout2" ? /* @__PURE__ */ o(En, { ...e }) : null });
    }
  })
);
function Mt(e, t) {
  let i;
  return function(...a) {
    clearTimeout(i), i = setTimeout(() => e(...a), t);
  };
}
const wt = {
  content: [
    {
      id: "account",
      items: [
        {
          id: "login",
          label: "Login",
          link: "/login"
        },
        {
          id: "register",
          label: "Register",
          link: "/register"
        },
        {
          id: "wishlist",
          label: "Wishlist",
          link: "/wishlist"
        }
      ]
    },
    {
      id: "support",
      items: [
        {
          id: "returns",
          label: "Returns",
          link: "/returns"
        },
        {
          id: "FAQ",
          label: "FAQ",
          link: "/faq"
        }
      ]
    },
    {
      id: "country-picker",
      items: [
        {
          id: "country-picker",
          component: "CountryPicker"
        }
      ]
    }
  ],
  navigation: [
    {
      label: "Men",
      id: "men",
      submenu: [
        {
          label: "Featured",
          id: "men-featured",
          link: "/men/featured",
          submenu: [
            {
              label: "New Arrivals",
              id: "men-new-arrivals",
              link: "/men/featured/new-arrivals"
            },
            {
              label: "Sale",
              id: "men-sale",
              link: "/men/featured/sale",
              featured: !0
            },
            {
              label: "Coming Soon",
              id: "men-coming-soon",
              link: "men/featured/coming-sooon"
            }
          ]
        },
        {
          label: "Shoes",
          id: "men-shoes",
          link: "/men/shoes",
          submenu: [
            {
              label: "Sneakers",
              id: "men-shoes-sneakers",
              link: "/men/shoes/sneakers"
            },
            {
              label: "Runing Lifestyle",
              id: "men-shoes-running-lifestyle",
              link: "men/shoes/running-lifestyle"
            },
            {
              label: "Basketball",
              id: "men-shoes-basketball",
              link: "/men/shoes/basketball"
            },
            {
              label: "Soccer",
              id: "men-shoes-soccer",
              link: "/men/shoes/soccer"
            },
            {
              label: "Court",
              id: "men-shoes-court",
              link: "/men/shoes/court"
            }
          ]
        },
        {
          label: "Brands",
          id: "men-brands",
          link: "/men/brands",
          submenu: [
            {
              label: "Nike",
              id: "men-shoes-nike",
              link: "/men/shoes/nike"
            },
            {
              label: "Adidas",
              id: "men-shoes-addias",
              link: "men/shoes/addias"
            },
            {
              label: "New Balance",
              id: "men-shoes-new-balance",
              link: "/men/shoes/new-balance"
            },
            {
              label: "Converse",
              id: "men-shoes-converse",
              link: "/men/shoes/converse"
            },
            {
              label: "Puma",
              id: "men-shoes-puma",
              link: "/men/shoes/puma"
            },
            {
              label: "Vans",
              id: "men-shoes-vans",
              link: "/men/shoes/vans"
            }
          ]
        },
        {
          label: "Air Jordan Collection 2049",
          id: "men-air-jordan-collection-2049",
          link: "/men/air-jordan-collection-2049",
          image: "https://images.unsplash.com/photo-1491553895911-0055eca6402d?q=80&w=3000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        }
      ]
    },
    {
      label: "Women",
      id: "women",
      submenu: [
        {
          label: "Featured",
          id: "women/featured",
          link: "/women/featured",
          submenu: [
            {
              label: "New Arrivals",
              id: "women/new-arrivals",
              link: "/women/featured/new-arrivals"
            },
            {
              label: "Sale",
              id: "women/sale",
              link: "/women/featured/sale",
              featured: !0
            },
            {
              label: "Coming Soon",
              id: "women/coming-soon",
              link: "men/featured/coming-sooon"
            }
          ]
        },
        {
          label: "Shoes",
          id: "women/shoes",
          link: "/women/shoes",
          submenu: [
            {
              label: "Sneakers",
              id: "women/shoes-sneakers",
              link: "/women/shoes/sneakers"
            },
            {
              label: "Runing Lifestyle",
              id: "women/shoes-running-lifestyle",
              link: "men/shoes/running-lifestyle"
            },
            {
              label: "Basketball",
              id: "women/shoes-basketball",
              link: "/women/shoes/basketball"
            },
            {
              label: "Soccer",
              id: "women/shoes-soccer",
              link: "/women/shoes/soccer"
            },
            {
              label: "Court",
              id: "women/shoes-court",
              link: "/women/shoes/court"
            }
          ]
        },
        {
          label: "Brands",
          id: "women/brands",
          link: "/women/brands",
          submenu: [
            {
              label: "Nike",
              id: "women/shoes-nike",
              link: "/women/shoes/nike"
            },
            {
              label: "Adidas",
              id: "women/shoes-addias",
              link: "men/shoes/addias"
            },
            {
              label: "New Balance",
              id: "women/shoes-new-balance",
              link: "/women/shoes/new-balance"
            },
            {
              label: "Converse",
              id: "women/shoes-converse",
              link: "/women/shoes/converse"
            },
            {
              label: "Puma",
              id: "women/shoes-puma",
              link: "/women/shoes/puma"
            },
            {
              label: "Vans",
              id: "women/shoes-vans",
              link: "/women/shoes/vans"
            }
          ]
        }
      ]
    },
    {
      label: "Kids",
      id: "kids",
      submenu: [
        {
          label: "Featured",
          id: "kids/featured",
          link: "/kids/featured",
          submenu: [
            {
              label: "New Arrivals",
              id: "kids/new-arrivals",
              link: "/kids/featured/new-arrivals"
            },
            {
              label: "Sale",
              id: "kids/sale",
              link: "kids/featured/sale",
              featured: !0
            },
            {
              label: "Coming Soon",
              id: "kids/coming-soon",
              link: "kids/featured/coming-sooon"
            }
          ]
        },
        {
          label: "Boy Shoes",
          id: "kids/boy-shoes",
          link: "/kids/boy-shoes",
          submenu: [
            {
              label: "Sneakers",
              id: "kids/boy-shoes-sneakers",
              link: "/kids/boy-shoes/sneakers"
            },
            {
              label: "Runing Lifestyle",
              id: "kids/boy-shoes-running-lifestyle",
              link: "men/boy-shoes/running-lifestyle"
            },
            {
              label: "Basketball",
              id: "kids/boy-shoes-basketball",
              link: "/kids/boy-shoes/basketball"
            },
            {
              label: "Soccer",
              id: "kids/boy-shoes-soccer",
              link: "/kids/boy-shoes/soccer"
            },
            {
              label: "Court",
              id: "kids/boy-shoes-court",
              link: "/kids/shoes/court"
            }
          ]
        },
        {
          label: "Girl Shoes",
          id: "kids/girl-shoes",
          link: "/kids/girl-shoes",
          submenu: [
            {
              label: "Sneakers",
              id: "kids/girl-shoes-sneakers",
              link: "/kids/girl-shoes/sneakers"
            },
            {
              label: "Runing Lifestyle",
              id: "kids/girl-shoes-running-lifestyle",
              link: "men/girl-shoes/running-lifestyle"
            },
            {
              label: "Basketball",
              id: "kids/girl-shoes-basketball",
              link: "/kids/girl-shoes/basketball"
            },
            {
              label: "Soccer",
              id: "kids/girl-shoes-soccer",
              link: "/kids/girl-shoes/soccer"
            },
            {
              label: "Court",
              id: "kids/girl-shoes-court",
              link: "/kids/girl-shoes/court"
            }
          ]
        }
      ]
    }
  ]
}, qn = n.object({
  variants: n.custom().optional(),
  blueprint: n.custom().optional(),
  image: Ne.optional(),
  link: n.object({
    href: n.string().optional()
  }).optional(),
  badge: $.optional(),
  heading: n.string().optional()
}), xt = k(
  "FeaturedImage",
  S(
    qn,
    ({ variants: e, image: t, link: i, heading: a, badge: s }) => {
      const r = tn.styles(e), c = oe(), d = i != null && i.href ? c : "span";
      return /* @__PURE__ */ o("div", { className: r.wrapper, children: t && /* @__PURE__ */ u(d, { href: i != null && i.href ? i == null ? void 0 : i.href : "", children: [
        /* @__PURE__ */ o(te, { ...t, displaySize: "300px" }),
        /* @__PURE__ */ u("div", { className: r.content, children: [
          (s == null ? void 0 : s.label) && /* @__PURE__ */ o(G, { ...s }),
          a && /* @__PURE__ */ o("div", { className: r.heading, children: a })
        ] })
      ] }) });
    }
  )
), Ue = n.object({
  variants: n.custom().optional(),
  layout: mn.shape.layout.optional(),
  blueprint: n.custom().optional(),
  badge: $.optional(),
  limitProducts: n.string().optional()
}), Ct = k(
  "FeaturedProduct",
  S(
    Ue,
    ({ variants: e, layout: t, badge: i, limitProducts: a }) => {
      const s = ge, l = un(), r = s.styles(e);
      return /* @__PURE__ */ u(hn, { layout: { ...t }, className: r.wrapper, children: [
        (i == null ? void 0 : i.label) && /* @__PURE__ */ o(G, { ...i }),
        /* @__PURE__ */ o("div", { className: r.products, children: l && l.slice(0, a ? Number(a) : l.length).map((c, d) => /* @__PURE__ */ o("div", { children: c.type === "product" ? /* @__PURE__ */ o(
          rn,
          {
            product: c.product,
            context: {
              type: "plp",
              listId: "featured",
              listName: "Featured",
              position: d
            },
            children: /* @__PURE__ */ o(Kn, {})
          }
        ) : c.type === "component" ? c.data : null }, d)) })
      ] });
    }
  )
), Kn = k(
  "FeaturedProduct",
  S(Ue, ({ variants: e }) => {
    const i = ge.styles(e), a = oe(), { slug: s } = cn(), r = dn()[0];
    return r ? /* @__PURE__ */ o("div", { className: i.product, children: /* @__PURE__ */ o(a, { href: s, context: "menu-product-card", className: i.link, children: /* @__PURE__ */ o(
      te,
      {
        initial: r,
        displaySize: "66px",
        className: i.image
      }
    ) }) }) : null;
  })
), Qn = k(
  "MenuItemSubmenuSlideIn",
  S(
    {
      schema: je,
      defaultProps: {
        heading: {
          badge: {
            enabled: !1
          }
        },
        slideOpen: !1
      }
    },
    ({
      children: e,
      variants: t,
      heading: i,
      parentId: a,
      slideOpen: s
    }) => {
      var y, I;
      const { active: l, history: r, prevActiveId: c, headerHeight: d } = j(), g = (Fe() || fe).styles(t), N = `w-full absolute top-0 left-[100%] ${l.id === a || c === a || r.some((H) => H.id === a) ? "opacity-100" : "opacity-0 pointer-events-none overflow-y-hidden"}`, h = A(
        s ? N : void 0,
        g.submenu
      ), b = A(
        s ? [g.scrollContainer, `h-[calc(100vh-${d}px)]`] : void 0
      );
      return /* @__PURE__ */ o("div", { className: h, children: /* @__PURE__ */ u(
        "div",
        {
          className: b,
          style: s ? { height: `calc(100dvh - ${d || 0}px)` } : void 0,
          children: [
            (i == null ? void 0 : i.heading) && ((y = i == null ? void 0 : i.badge) == null ? void 0 : y.enabled) && /* @__PURE__ */ o("span", { className: g.submenuHeading, children: /* @__PURE__ */ o(
              G,
              {
                className: g.badge,
                label: i.heading,
                ...i == null ? void 0 : i.badge
              }
            ) }),
            (i == null ? void 0 : i.heading) && !((I = i == null ? void 0 : i.badge) != null && I.enabled) && /* @__PURE__ */ o("span", { className: g.submenuHeading, children: i == null ? void 0 : i.heading }),
            e
          ]
        }
      ) });
    }
  )
), O = (e) => e != null && e.label ? /* @__PURE__ */ o(
  G,
  {
    label: e.label,
    ...e,
    className: e.className
  }
) : null, Un = k(
  "MenuItem",
  S(
    {
      schema: Y,
      defaultProps: {
        nextIcon: /* @__PURE__ */ o(ie, {}),
        level: 1
      }
    },
    ({
      variants: e,
      label: t = "",
      children: i,
      style: a,
      id: s = "",
      link: l,
      submenu: r,
      level: c,
      badge: d,
      nextIcon: m
    }) => {
      const { active: g, nextLevel: f } = j(), h = (Fe() || fe).styles(e), b = oe(), y = en();
      s = s || y;
      const I = ne(
        () => Array.isArray(i) && i.length > 0 ? p.Children.map(i, (L) => {
          if (!p.isValidElement(L))
            return L;
          const de = p.Children.map(
            L.props.children,
            (K) => p.isValidElement(K) ? p.cloneElement(K, {
              id: pn(),
              parentId: s,
              parentLabel: t,
              level: c ? c + 1 : 1
              // Increment level
            }) : K
          );
          return le(L) ? p.cloneElement(L, {
            children: de,
            // Replace the child's children with the enhanced ones
            // isNested: isNested,
            slideOpen: r == null ? void 0 : r.slideOpen
          }) : /* @__PURE__ */ o("div", { className: h.submenuComponent, children: p.cloneElement(L, {
            children: de,
            // Pass enhanced children to non-MenuItem elements
            context: "menu"
            // So all linky components are handled as menu links
          }) });
        }) : !1,
        [
          i,
          s,
          t,
          c,
          h.submenuComponent,
          r == null ? void 0 : r.slideOpen
        ]
      ), H = I && (r == null ? void 0 : r.slideOpen), ce = () => f(g.level + 1, t, s);
      return /* @__PURE__ */ u("div", { className: h.wrapper, style: a, children: [
        (l == null ? void 0 : l.href) && !H && t && /* @__PURE__ */ o("div", { className: h.item, "data-level": c, children: /* @__PURE__ */ u(b, { href: l == null ? void 0 : l.href, className: h.label, context: "menu", children: [
          /* @__PURE__ */ o("span", { className: h.link, children: t }),
          /* @__PURE__ */ o(O, { ...d, className: h.badge })
        ] }) }),
        !(l != null && l.href) && !H && t && /* @__PURE__ */ o("div", { className: h.item, "data-level": c, children: /* @__PURE__ */ u("span", { className: h.label, children: [
          t,
          /* @__PURE__ */ o(O, { ...d, className: h.badge })
        ] }) }),
        !(l != null && l.href) && H && t && /* @__PURE__ */ u(
          "button",
          {
            onClick: ce,
            className: h.item,
            "data-level": c,
            children: [
              /* @__PURE__ */ u("span", { className: h.label, children: [
                t,
                /* @__PURE__ */ o(O, { ...d, className: h.badge })
              ] }),
              /* @__PURE__ */ o("span", { className: h.goToNextLevel, children: m })
            ]
          }
        ),
        (l == null ? void 0 : l.href) && H && t && /* @__PURE__ */ u(
          "button",
          {
            onClick: ce,
            className: h.item,
            "data-level": c,
            children: [
              /* @__PURE__ */ u("span", { className: h.label, children: [
                t,
                /* @__PURE__ */ o(O, { ...d, className: h.badge })
              ] }),
              /* @__PURE__ */ o("span", { className: h.goToNextLevel, children: m })
            ]
          }
        ),
        I && /* @__PURE__ */ o(
          Qn,
          {
            children: I,
            parentId: s,
            heading: r == null ? void 0 : r.heading,
            level: c,
            slideOpen: r == null ? void 0 : r.slideOpen
          }
        )
      ] });
    }
  )
);
Un.displayName = "MenuItem";
export {
  In as ActiveMenu,
  yn as ContentSection,
  wt as DEMO_SITE_DATA_SET,
  Gn as Deck2Menu,
  Ke as Deck2MenuDataProvider,
  Ln as Deck2MenuItem,
  Wn as Deck2MenuRender,
  Fn as Deck2MenuRenderSub,
  Tn as Deck2MenuRenderTop,
  qe as Deck2MenuStateProvider,
  Vn as Deck2Submenu,
  _n as Deck2WindowEvents,
  He as DeckMenu,
  D as DeckMenuContext,
  xt as FeaturedImage,
  Ct as FeaturedProducts,
  En as Foldout2Menu,
  Cn as Foldout2MenuHeader,
  Yn as FoldoutMenu,
  R as GenericProps,
  fn as HiddenMenu,
  Nt as Menu,
  Pe as MenuAsDeckSchema,
  Ae as MenuAsHiddenSchema,
  Le as MenuAsSidebarSchema,
  gn as MenuContentSchema,
  Un as MenuItem,
  Qn as MenuItemSubmenuSlideIn,
  ae as MenuPropsSchemaHelper,
  xn as MenuProvider,
  Z as NavigationItemSchema,
  vn as NavigationLevel2,
  bn as NavigationLevel3,
  Nn as Overlay,
  De as SidebarMenu,
  Mn as SidebarMenuContext,
  Ee as TriggerSchema,
  se as Triggers,
  St as TriggersSchema,
  Bn as containerVariants,
  Mt as debounce,
  ze as deck2MenuDataContext,
  $e as deck2MenuDispatchContext,
  We as deck2MenuItemSchema,
  Hn as deck2MenuReducer,
  _e as deck2MenuStateContext,
  Ve as deck2Schema,
  qn as featuredImageSchema,
  Ue as featuredProductsSchema,
  V as flattenSingleItemArrays,
  Be as foldout2MenuHeaderSchema,
  Oe as foldout2Schema,
  Qe as foldoutSchema,
  It as isButtonAsLink,
  le as isMenuItem,
  Re as menuItemBlueprintContext,
  An as menuItemLinkSchema,
  Y as menuItemSchema,
  je as menuItemSubmenuSchema,
  zn as menuPropsSchema,
  U as removeFragments,
  Pn as restructureMenuData,
  jn as submenuItemVariants,
  Ge as useDeck2ItemClick,
  re as useDeck2MenuData,
  q as useDeck2MenuDispatch,
  z as useDeck2MenuState,
  Rn as useDeck2SubmenuPointerLeave,
  Dn as useDeck2TopLinkPointerEnter,
  j as useMenu,
  Fe as useMenuItemBlueprint
};
//# sourceMappingURL=index.es.js.map
